// extracted by mini-css-extract-plugin
export default {"btnpwd":"_47aebec832"};